import store from '@/core/store';

async function isUserInfoReady() {
   return new Promise((resolve) => checkUserInfo(resolve));
}

async function checkUserInfo(resolve: (value?: any) => void) {
   if (!store.state.userInfo?.loadingUserInfo) {
      resolve();
   } else {
      setTimeout(() => checkUserInfo(resolve), 500);
   }
}

export { isUserInfoReady };
